<template lang="pug">
div
  search(:pagination='this.paginationTravel')
  h4( class="mb-2 ml-2")
    v-icon(color="orange" class="mr-2" v-text="table.tableOffline.offline ? 'wifi_off' : ''" )
    span(v-text="'Viagens'")

  v-data-table(
    :headers="table.headers"
    :items="tableOffline.itens"
    :server-items-length="table.tableOffline.viagens.total"
    :options.sync="paginationTravel"
    :items-per-page="5"
    :loading="tableOffline.loading"
    @click:row="detailsTravel"
    class="pa-3 "
    v-if="table.tableOffline.offline"

  )
    template(v-slot:item.action="{item}")
      v-btn( icon @click="detailsTravel(item)" )
        v-icon(v-text="'visibility'")

  v-data-table(
    :headers="table.headers"
    :items="table.viagens.itens"
    :server-items-length="table.viagens.total"
    :options.sync="paginationTravel"
    :items-per-page="5"
    :loading="table.viagens.loading"
    @click:row="detailsTravel"
    class="pa-3 "
    v-else
  )  
    template(v-slot:item.action="{item}")
      v-btn( icon @click="detailsTravel(item)" )
        v-icon(v-text="'visibility'")

</template>

<script>
// import viagensService from "@/services/viagens.service";
import GlobalStore from "@/store/modules/global";
// import { cadastroViagemDB } from "@/helpers/dexieDb";
import { Subject, throwError } from "rxjs";
import {
  tap,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import { mapState, mapActions } from "vuex";
import Search from "./search.vue";
import dayjs from "dayjs";
import { viagensOfflineDB } from "@/helpers/dexieDb";

export default {
  name: "MyTripsTable",
  components: {
    Search,
  },
  data: () => ({
    headers: [],
    headersSincronized: [],
    sincronized: {
      total: 10,
      itens: [],
      loading: false,
    },
    verify: true,
    viagemData: {},
    paginationTravel: {},
    idCacheIndexDB: "",
    tableOffline: { itens: "", loading: false },
  }),
  computed: {
    ...mapState("viagens", ["table"]),
  },
  watch: {
    "table.viagens": function () {
      this.getTravelOff();
    },
  },
  mounted() {
    this.getTravelOff();
  },
  methods: {
    backToTravelList() {
      this.$router.push({
        name: "my-trips",
      });
    },
    detailsTravel(travel) {
      if (this.table.tableOffline.offline) {
        this.$router.push({
          name: "my-trips-show",
          params: { id: travel.idCache },
        });
      } else {
        this.$router.push({
          name: "my-trips-show",
          params: { id: travel.id },
        });
      }
    },

    async getTravelOff() {
      this.tableOffline.loading = true;
      const travels = await viagensOfflineDB.viagens
        .toArray()
        .then((res) => {
          this.tableOffline.itens = res;
          this.tableOffline.loading = false;
        })
        .catch((err) => {
          this.tableOffline.loading = false;
        });
    },
  },
};
</script>
